import Const from 'const';

export interface FilterPositionInterface {
    getKey(): string;
    getValue(): string | any[];
    getPositionNames(): string[];
    isKeyEqual(key: string): boolean;
    isKeyFlex(): boolean;
    isKeySuperFlex(): boolean;
}

interface Position {
    readonly key: string;
    readonly map: object;
}

export class FilterPosition implements FilterPositionInterface {
    constructor(
        private readonly key: string,
        private readonly value: string | any[],
        private readonly positionMap: object = {},
    ) {}
    getKey(): string {
        return this.key;
    }
    getValue(): string | any[] {
        return this.value;
    }
    getPositionNames(): string[] {
        return Object.values(this.positionMap).map(String);
    }
    isKeyEqual(key: string): boolean {
        return this.key === key;
    }
    isKeyFlex(): boolean {
        return this.key.toLowerCase() === 'flex';
    }
    isKeySuperFlex(): boolean {
        return this.key.toLowerCase() === 's-flex';
    }
}

export function createOverallFilterPosition(): FilterPositionInterface {
    return new FilterPosition(Const.OVERALL_MODE, Const.OVERALL_MODE);
}

export function isOverallFilterPosition(filterPosition: FilterPositionInterface): boolean {
    return Const.OVERALL_MODE === filterPosition.getKey();
}

export function createFilterPosition(position: Position): FilterPositionInterface {
    return new FilterPosition(position.key, Object.keys(position.map).map(Number), position.map);
}

export function createFilterPositionByKeyAndPositions(key: string, positions: Position[]): FilterPositionInterface {
    const positionNumbers: number[] = [];
    const positionMap: object = {};
    Object.values(positions).map((position) => {
        Object.keys(position.map).map((key) => {
            positionNumbers.push(Number(key));
            positionMap[key] = position.map[key];
        });
    });

    return new FilterPosition(key, positionNumbers, positionMap);
}
